import { useState } from "react";
import { faqs } from "@/mocks/doujin";

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-medium tracking-wide text-secondary-600">常见问题</span>
          <h2 className="font-heading mt-2 text-2xl text-foreground-950 md:text-4xl">
            你可能想知道
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            关于作品形式、分类浏览与版权问题的常见解答。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-transform ${
                      open ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg" />
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}